/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var LogoMicrosoftIcon16Regular = forwardRef('LogoMicrosoftIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1.25 3c0-.966.784-1.75 1.75-1.75h10c.966 0 1.75.784 1.75 1.75v10A1.75 1.75 0 0 1 13 14.75H3A1.75 1.75 0 0 1 1.25 13V3Zm1.5 5.75V13c0 .138.112.25.25.25h4.25v-4.5h-4.5Zm4.5-1.5h-4.5V3A.25.25 0 0 1 3 2.75h4.25v4.5Zm1.5 1.5v4.5H13a.25.25 0 0 0 .25-.25V8.75h-4.5Zm4.5-1.5h-4.5v-4.5H13a.25.25 0 0 1 .25.25v4.25Z" })));
});
